/**
 * Real state lots
 */
export const LotSaleStatus = Object.freeze({
  INACTIVE: 0,
  ACTIVE: 1,
  CANCELLED: 2,
});

const ReservationType = Object.freeze({
  INITIAL: 0,
  PARTIAL: 1,
  TOTAL: 2,
});

/**
 * Financing
 */
const FinancingPlanStatus = Object.freeze({
  INACTIVE: 0,
  ACTIVE: 1,
  PAID: 2,
  REFINANCED: 3,
  CANCELLED: 4,
});

const DiscountType = Object.freeze({
  NONE: 0,
  PERCENTAGE: 1,
  FIXED: 2,
});

const InstallmentStatus = Object.freeze({
  INACTIVE: 0,
  ACTIVE: 1,
  PAID: 2,
});

const FinancingPeriodType = Object.freeze({
  MONTHLY: 0,
  ANNUAL: 1,
});

const SaleType = Object.freeze({
  CASH: 0,
  CREDIT: 1,
  FINANCED: 2,
});

function getKey(enumObj, value) {
  return Object.keys(enumObj).find(key => enumObj[key] === value);
}

export default {
  // Financing
  DiscountType,
  InstallmentStatus,
  FinancingPeriodType,
  FinancingPlanStatus,
  SaleType,
  // real state lots
  LotSaleStatus,
  ReservationType,
  getKey,
}